import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";

export const getTruckDetails = createAsyncThunk("trucks", async () => {
  try {
    const response = await fetch(
      `${process.env.REACT_APP_BACKEND_URL}/AllTruck/`,
      //`http://localhost:5000/AllTruck/`,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          auth_token: "Bearer " + sessionStorage.getItem("user_auth_token"),
        },
        body: JSON.stringify(),
      }
    );

    const json = await response.json();
    // console.log("json : ", json);
    return json;
  } catch (error) {
    // console.log(error);
    return error;
  }
});

export const getDriverDetails = createAsyncThunk("driver", async () => {
  try {
    const response = await fetch(
      `${process.env.REACT_APP_BACKEND_URL}/AllDriver/`,
      //`http://localhost:5000/AllDriver/`,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          auth_token: "Bearer " + sessionStorage.getItem("user_auth_token"),
        },
        body: JSON.stringify(),
      }
    );
    const json = await response.json();
    // console.log("json : ", json);
    return json;
  } catch (error) {
    // console.log(error);
    return error;
  }
});
export const getClientDetails = createAsyncThunk("parties", async () => {
  try {
    const response = await fetch(
      `${process.env.REACT_APP_BACKEND_URL}/Allclient/`,
      //`http://localhost:5000/Allclient/`,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          auth_token: "Bearer " + sessionStorage.getItem("user_auth_token"),
        },
        body: JSON.stringify(),
      }
    );
    const json = await response.json();
    // console.log("json : ", json);
    return json;
  } catch (error) {
    // console.log(error);
    return error;
  }
});
export const getMyProfile = createAsyncThunk("profile", async () => {
  try {
    const response = await fetch(
      `${process.env.REACT_APP_BACKEND_URL}/myprofile/`,
      //`http://localhost:5000/Allclient/`,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          auth_token: "Bearer " + sessionStorage.getItem("user_auth_token"),
        },
        body: JSON.stringify(),
      }
    );
    const json = await response.json();
    // console.log("json : ", json);
    return json;
  } catch (error) {
    // console.log(error);
    return error;
  }
});

export const getEwayBillDetails = createAsyncThunk("ewaybills", async () => {
  try {
    const response = await fetch(
      `${process.env.REACT_APP_BACKEND_URL}/num`,
      //`http://localhost:5000/num`,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          auth_token: "Bearer " + sessionStorage.getItem("user_auth_token"),
        },
        body: JSON.stringify(),
      }
    );
    const json = await response.json();

    // return json;
    const reversedData = json.num.reverse(); // reverse the order of the results
    console.log("ewaybill details : ", reversedData);
    return { ...json, num: reversedData }; // return the updated response object
  } catch (error) {
    // console.log(error);
    return error;
  }
});

const dataSlice = createSlice({
  name: "dataSlice",
  initialState: {
    trucks: [],
    parties: [],
    drivers: [],
    ewaybills: [],
    profile: [],
    statusAuth: false,
    status: "ok",
  },
  reducers: {
    setStatusAuth: (state, action) => {
      state.statusAuth = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getTruckDetails.fulfilled, (state, action) => {
        state.trucks = action.payload;
      })
      .addCase(getDriverDetails.fulfilled, (state, action) => {
        state.drivers = action.payload;
      })
      .addCase(getClientDetails.fulfilled, (state, action) => {
        state.parties = action.payload;
      })
      .addCase(getEwayBillDetails.fulfilled, (state, action) => {
        state.ewaybills = action.payload;
      })
      .addCase(getMyProfile.fulfilled, (state, action) => {
        state.profile = action.payload;
      });
  },
});
export const { setStatusAuth } = dataSlice.actions;
export default dataSlice.reducer;
